<template>
  <b-modal v-model="isShow">
    <template #modal-title>
      {{ $t('Select Language') }}
    </template>
    <b-container fluid>
      <b-row class="mb-1 text-center">
        <b-col>
          <b-button @click="language('en')" variant="outline-secondary">
            English
          </b-button>
        </b-col>
        <b-col>
          <b-button @click="language('ko')" variant="outline-secondary">
            한국어
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <template #modal-footer="{ ok }">
      <div class="w-100">
        <b-button variant="primary" size="sm" class="float-right" @click="ok">
          {{ $t('Close') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'LanguagePopup',
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    ...mapState(['languagePopupData'])
  },
  methods: {
    ...mapActions(['setLanguage']),
    language(language) {
      this.setLanguage(language)
      this.isShow = false
    }
  },
  watch: {
    languagePopupData() {
      if (this.languagePopupData.isShow) {
        this.isShow = true
      }
    }
  }
}
</script>

<style></style>
